import { HOME, MARKETPLACE, CONTACT_US, ABOUT_US } from "./routes";
import AuthBg from "../images/AuthBg.jpeg";
import FaceBook from "../images/Facebook.svg";
import Instagram from "../images/Instagram.svg";
import Linkedin from "../images/LinkedIn.svg";
import Twitter from "../images/Twitter.svg";
import MainHome from "../images/MainHome.jpg";
import Home1 from "../images/ImageHome1.png";
import Home2 from "../images/ImageHome2.png";
import Home3 from "../images/ImageHome3.png";
import cryptoImage from "../images/crypto.png";
import Left from "../images/Left.png";
import Right from "../images/Right.png";
import Usa from "../images/usa.png";
import France from "../images/france.png";
import Spain from "../images/spain.png";
import England from "../images/england.png";
import Banner from "../images/Banner.png";
import BBuilding from "../images/BannerBuilding.jpg";
import BannerBuilding from "../images/Building.png";
import FirstAbout from "../images/AboutFirst.jpg";
import AboutStars from "../images/AboutStars.jpg";
import VideoImage from "../images/Video.jpg";
import Avatar1 from "../images/Avatar1.png";
import Avatar2 from "../images/Avatar2.png";
import Avatar3 from "../images/Avatar3.png";
import Marker from "../images/Marker.png";
import apartment from "../images/Apartment.png";

export const AuthImage = AuthBg;
export const Main = MainHome;
export const Crypto = cryptoImage;
export const BannerBG = Banner;
export const BBimage = BBuilding;
export const Build = BannerBuilding;
export const AboutFirst = FirstAbout;
export const Stars = AboutStars;
export const Video = VideoImage;
export const GoogleMarker = Marker;

export const HomeImagesList = {
  first: Home1,
  second: Home2,
  third: Home3,
};

export const landingDecor = {
  left: Left,
  right: Right,
};

export const menuLinks = [
  {
    text: "HOME",
    link: HOME,
  },
  {
    text: "ABOUT",
    link: ABOUT_US,
  },
  {
    text: "CONTACT",
    link: CONTACT_US,
  },
  {
    text: "MARKETPLACE",
    link: MARKETPLACE,
  },
];

export const footerSocial = [
  {
    link: FaceBook,
    href: "#",
  },
  {
    link: Instagram,
    href: "#",
  },
  {
    link: Linkedin,
    href: "#",
  },
  {
    link: Twitter,
    href: "#",
  },
];

export const TakeTour = [
  {
    rours: [
      {
        link: "Features",
        href: "#",
      },
      {
        link: "Partners",
        href: "#",
      },
      {
        link: "Pricing",
        href: "#",
      },
      {
        link: "Product",
        href: "#",
      },
      {
        link: "Support",
        href: "#",
      },
    ],
    title: "Take a tour",
  },
];

export const OurCompany = [
  {
    OurCompany: [
      {
        link: "About us",
        href: "#",
      },
      {
        link: "Agents",
        href: "#",
      },
      {
        link: "Blog",
        href: "#",
      },
      {
        link: "Media",
        href: "#",
      },
      {
        link: "Contact us",
        href: "#",
      },
    ],
    title: "Our Company",
  },
];

export const availableCountries = [
  { country: Usa },
  { country: Spain },
  { country: England },
  { country: France },
];

export const membersSaid = [
  {
    avatar: Avatar1,
    text: "I had a wonderful experience with this real estate agency. The team was incredibly helpful and knowledgeable. They listened attentively to my preferences, guiding me through the process with professionalism and care. Thanks to their expertise, I found the perfect home. Highly recommend!",
  },

  {
    avatar: Avatar2,
    text: "Exceptional service! The real estate agents demonstrated a high level of professionalism and dedication. They were attentive to my specific needs, providing valuable insights throughout the entire home-buying process. I'm extremely satisfied with their expertise and would gladly recommend this agency to others.",
  },

  {
    avatar: null,
    name: "Roman",
    text: "Working with this real estate agency has been a pleasure. The team's knowledge and dedication were evident from the start. They took the time to understand my preferences and priorities, ensuring a tailored approach to finding the perfect home. Their responsiveness and guidance throughout the process were exceptional. I would undoubtedly recommend this agency for anyone in need of top-notch real estate services.",
  },

  {
    avatar: null,
    name: "Elena",
    text: "I had a fantastic experience with this real estate agency. The agents were not only highly professional but also genuinely invested in helping me find the right property. Their expertise and attention to detail were evident in every step of the process. I felt supported and informed throughout, resulting in a smooth and successful home purchase. I highly recommend this agency for their outstanding service and commitment to client satisfaction.",
  },

  {
    avatar: null,
    name: "John",
    text: "Choosing this real estate agency was a wise decision. The team's professionalism and commitment to client satisfaction were evident throughout my home-buying journey. They provided valuable insights, listened to my concerns, and guided me seamlessly through the process. I am now a happy homeowner, thanks to their dedication and expertise. I highly recommend this agency to anyone in search of a reliable and customer-focused real estate partner.",
  },
  {
    avatar: Avatar3,
    text: "I cannot express how grateful I am for the outstanding service provided by this real estate agency. From the initial consultation to the closing process, the team exhibited unparalleled professionalism and attention to detail. Their commitment to understanding my requirements and finding the right property made the entire experience seamless and enjoyable. I highly recommend this agency to anyone in search of a reliable and customer-centric real estate partner.",
  },
];

export const apartments = [
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
  {
    image: apartment,
    street: " 103/143 West Street Crows Nest",
    description: "10 Bedroom 150 M 2 Garage",
    posted: "Posted by X Builder",
    price: "$45,545",
  },
];
